import React, { PropTypes } from 'react';
import { Card } from 'material-ui';

const SignUp = props => {
  const {
    postCompName,
  } = props;

  return (
    <Card style={{ width: '62%', margin: '10px 0 0 23%', padding: '1% 2%', color: 'rgba(0, 0, 0, 0.54)' }}>
      <div style={{ fontSize: '16px' }}>
        To view <b>{postCompName}</b> profile, <a
          href={`${window.location.protocol}//${window.location.host}/signin`}
          target="_blank"
        >Sign In</a> or <a
          href={`${window.location.protocol}//${window.location.host}/signup`}
          target="_blank"
        >Sign Up</a> for an account on TourConnect!
      </div>
    </Card>
  );
};

SignUp.propTypes = {
  postCompName: PropTypes.string,
};

export default SignUp;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/postPage/signup.jsx